import { useQuery } from '@tanstack/react-query';
import { fetchReviewCounts } from '@/lib/conversationReviews.ts';
import { useOrganisationFilter } from '@/lib/activeOrganisation.ts';

/**
 * Open critical and high reviews in the organisation chosen in the header. The
 * key sits under `conversationReviewCounts`, so handling a review refreshes it.
 */
export function useOpenUrgentReviewCount(): number {
  const organisationId = useOrganisationFilter()?.id;

  const { data } = useQuery({
    queryKey: ['conversationReviewCounts', 'openUrgent', organisationId ?? null],
    queryFn: () =>
      fetchReviewCounts({
        handled: 'open',
        organisation_ids: organisationId ? [organisationId] : undefined,
      }),
  });

  return data ? data.critical + data.high : 0;
}
